<div class="h-full flex flex-col" [class]="floatingPageClasses()">
  <h5
    class="text-neutral-900 font-semibold text-2xl"
    [class.mb-lg]="floating()">
    {{ 'positions_list_screen_title' | transloco }}
  </h5>

  <ng-template #tableActionSectionRef>
    <a
      class="flex items-center bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm"
      [routerLink]="[ADMIN_ROUTES.POSITIONS.FORM | tenantPath: 'admin']"
      id="positions_list_screen_new_position_button">
      <lib-add-icon [iconClass]="'size-5 text-white'" />

      <span class="hidden md:block">
        {{ 'positions_list_screen_new_position_button' | transloco }}
      </span>
    </a>
  </ng-template>

  <lib-filtered-table
    [tableId]="'positions'"
    [tableTitle]="'positions_list_screen_all_positions' | transloco"
    [dataSource]="positionList()"
    [titleClass]="floating() ? '' : 'mb-2xl pb-lg'"
    [lastColumnAlignment]="'justify-end'"
    [meta]="meta()"
    [columns]="columns()"
    [isLoadingData]="isLoading()"
    [tableFilterTabs]="tableFilterTabs()"
    [(payload)]="payload"
    [tableActionSectionRef]="tableActionSectionRef"
    [isTableExportable]="false"
    [tableColumnTemplates]="
      [
        { template: number, identifier: '' },
        { template: identifier, identifier: '' },
        { template: name, identifier: '' },
        { template: assigned_user, identifier: '' },
        { template: direct_manager, identifier: '' },
        {
          template: status,
          identifier: POSITION_LIST_COLUMN_IDENTIFIERS.STATUS,
        },
        {
          template: filled_status,
          identifier: POSITION_LIST_COLUMN_IDENTIFIERS.FILLED_STATUS,
        },
        { template: action, identifier: '' },
      ]
        | filterTableColByFeatFlag
          : isPositionStatuesEnhancementEnabled()
          : POSITION_LIST_COLUMN_IDENTIFIERS.FILLED_STATUS
    "
    [applyOnStreamChanges]="getPositionList$"
    (streamSucceeds)="handlePositionListSuccess($event)"
    (handleApiCall)="getPositionList()"
    (handleViewIconClick)="viewPositionDetails($event)" />
</div>

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #identifier let-row>
  <span class="text-neutral-900 text-xs font-medium">
    {{ row?.identifier ?? '' }}
  </span>
</ng-template>

<ng-template #name let-row>
  <span class="text-neutral-900 text-xs font-medium">
    {{ row?.name }}
  </span>
</ng-template>

<ng-template #assigned_user let-row>
  <div class="flex items-center gap-lg">
    <lib-avatar
      [fullName]="row?.incumbent?.name"
      [img]="row?.incumbent?.image?.url"
      borderRadius="rounded-full"></lib-avatar>
    <span class="text-neutral-900 text-xs font-medium">
      {{ row?.incumbent?.name ?? '' }}
    </span>
  </div>
</ng-template>

<ng-template #direct_manager let-row>
  <span class="text-neutral-900 text-xs font-medium">
    {{ row?.reports_to_position?.name ?? '' }}
  </span>
</ng-template>

<ng-template #status let-row>
  @if (row.state) {
    <lib-badge
      [label]="row.state.label"
      [badgeClass]="
        'px-sm border-none text-xs font-medium text-white ' +
        (row.state.value | userStatus)
      " />
  }
</ng-template>

<ng-template #filled_status let-row>
  @let filledStatusLabel =
    row?.incumbent_user_id
      ? 'positions_list_screen_filled_status_filled'
      : 'positions_list_screen_filled_status_vacant';
  @let filledStatusClass = row?.incumbent_user_id ? 'active' : 'inactive';

  <lib-badge
    [label]="filledStatusLabel | transloco"
    [badgeClass]="
      'px-sm border-none text-xs font-medium text-white ' +
      (filledStatusClass | userStatus)
    " />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'positions'"
    [menuItems]="actionMenuItems()"
    (menuToggled)="selectedPosition.set(row)"
    (itemClick)="handleAction($event, row)" />
</ng-template>

<ng-template #deactivate>
  <div>
    <div class="text-center">
      <div
        class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
        <lib-close-square-icon
          viewBox="0 0 30 30"
          width="27"
          height="27"
          iconClass="text-destructive-500" />
      </div>
    </div>

    <p class="text-lg text-center font-medium mb-sm">
      {{ 'deactivate_position_modal_title' | transloco }}
    </p>

    <p class="text-sm text-neutral-500 text-center mb-4xl">
      {{ 'deactivate_position_modal_description' | transloco }}
      <span class="font-medium text-primary-500">
        {{ 'deactivate_position_modal_highlighted_description' | transloco }}
      </span>
    </p>

    <div class="flex flex-col gap-md text-base font-medium">
      <button
        [class.opacity-30]="isPositionStateLoading()"
        [disabled]="isPositionStateLoading()"
        (click)="deactivatePosition()"
        class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
        {{ 'deactivate_position_modal_deactivate_position_button' | transloco }}
      </button>

      <button
        [disabled]="isPositionStateLoading()"
        [class.opacity-30]="isPositionStateLoading()"
        (click)="closeModal()"
        class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
        {{ 'deactivate_position_modal_no_keep_it_button' | transloco }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #activate>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-primary-50 p-sm rounded-full mb-xl img-width-container">
      <lib-tick-square-icon iconClass="size-8 text-primary-500" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'activate_position_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'activate_position_modal_description' | transloco }}
    <span class="font-medium text-primary-500 block">
      {{ 'activate_position_modal_highlighted_description' | transloco }}
    </span>
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [disabled]="isPositionStateLoading()"
      (click)="activatePosition()"
      class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'activate_position_modal_activate_position_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'activate_position_modal_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #deleteRecord>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
      <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'delete_position_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'delete_position_modal_description' | transloco }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [class.opacity-30]="isPositionStateLoading()"
      [disabled]="isPositionStateLoading()"
      (click)="deletePosition()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'delete_position_modal_delete_position_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'delete_position_modal_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>
